import React from "react";
import "../styles/Account.css";

const Account = () => {
  return (
    <div className="account-container">
      <h2>Settings</h2>
    </div>
  );
};

export default Account;